import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {Button, Form} from "react-bootstrap";
import axios from "axios";
import Editor from "react-simple-wysiwyg";
import {RichEditor} from "../ipd/consentForms/RichEditor";

export const DiagnosticRecordUpdateView = forwardRef((props: { id: string, recordId: any, postAction: any, status: string }, ref) => {

    const [recordId, setRecordId] = useState<string>();
    const [record, setRecord] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [file, setFile] = useState<any>();
    const [diagnosis, setDiagnosis] = useState(null);
    let componentRef = useRef(null);


    useEffect(() => {
        if (props.id) {
            fetchRecord()
        }
    }, [props.id])

    useEffect(() => {
        if (props.recordId) {
            setRecordId(props.recordId)
        }
    }, [props.recordId])

    const handleChange = event => {
        setErrorMessage(null)
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB")
            } else {
                setFile(selectedFile);
            }
        }
    };

    function fetchRecord() {
        axios.get('/api/backend/customer/records/fetch/id/' + props.id)
            .then(resp => {
                setRecord(resp.data)
                if (resp.data) {
                    setFile(JSON.parse(resp.data.data).key)
                }
                if (resp.data.description && resp.data.description != "null") {
                    setDiagnosis(resp.data.description)
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            });
    }

    const uploadFile = async () => {

        let key = props.recordId + "_" + file.name
        let {data} = await axios.post("/api/s3/upload", {
            name: key,
            type: file.type,
        });

        console.log(data);

        const url = data.url;
        let {data: newData} = await axios.put(url, file, {
            headers: {
                "Content-type": file.type,
                "Access-Control-Allow-Origin": "*",
            },
        });

        console.log(newData);

        return key
    };


    const handleUpdate = (e) => {
        e.preventDefault();
        setErrorMessage(null)
        setLoading(true)
        if (file) {
            uploadFile()
                .then(resp => {
                    console.log(resp)

                    axios.post('/api/backend/customer/records/update/record/id/' + recordId, {
                        diagnosis: diagnosis,
                        data: {key: resp}
                    })
                        .then(resp => {
                            console.log(resp.data)
                            props.postAction()
                        })
                        .catch(err => {
                            setErrorMessage("Error while creating the record. Please verify the record Id")
                            console.error(err);
                            if (err.response && err.response!.status && err.response!.status === 403) {
                                handleLogout()
                            }
                            ;
                        }).finally(() => setLoading(false));
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                    setErrorMessage("Error while uploading the file")
                }).finally(() => setLoading(false));
        } else {
            axios.post('/api/backend/customer/records/update/record/id/' + recordId, {
                diagnosis: diagnosis,
                data: new Object({})
            })
                .then(resp => {
                    console.log(resp.data)
                    props.postAction()
                })
                .catch(err => {
                    setErrorMessage("Error while creating the record. Please verify the record Id")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                }).finally(() => setLoading(false));
        }
    }

    return (
        <>
            <>
                <div className="row">
                    {!props.recordId && props.status == "PENDING" && <div className="col col-12">
                        <Form.Group className="my-2" controlId="recordId">
                            <Form.Control value={recordId}
                                          onChange={e => setRecordId(e.target.value)}
                                          name="recordId" type="text"
                                          placeholder="Enter Record Id"
                                          className="form-control-sm"
                            />

                        </Form.Group>
                    </div>
                    }
                    <div className="col col-12">
                        <div className="my-2 d-flex gap-2">
                            <label className="align-self-center text-info">Report:</label>
                            <input type="file"
                                   ref={componentRef}
                                   className="form-control form-select-sm"
                                   accept=".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf"
                                   onChange={handleChange}/>
                        </div>
                    </div>
                    {record && JSON.parse(record.data).key && <div className="col col-12">
                        <div className="my-2 d-flex gap-2">
                            <label className="align-self-center text-info">View uploaded report :</label>
                            <a target="_blank" rel="noreferrer"
                               href={"/api/s3/download/?file=" + JSON.parse(record.data).key}
                               className="text-success font-weight-bold"> &#x2193;</a>
                        </div>
                    </div>}

                    <div className="col col-12">
                        <Form.Group className="my-2" controlId="diagnosis">
                            <label className="align-self-center text-info ">Report Details:</label>
                            <Editor
                                containerProps={{style: {resize: 'vertical', minHeight: "300px"}}}
                                value={diagnosis}
                                onChange={e => setDiagnosis(e.target.value)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="my-2">
                    <button className="btn btn-info text-white btn-sm"
                            onClick={e => handleUpdate(e)}>
                        {loading &&
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                </div>
                            </div>
                        }
                        {!loading && <>Add Report</>}
                    </button>
                    {errorMessage &&
                        <div className="text-danger fs-6">*{errorMessage}</div>
                    }
                </div>
            </>

        </>

    );
});

DiagnosticRecordUpdateView.displayName = "DiagnosticRecordUpdateView";